import React, {useEffect} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import AssignQuotePopupSearch from "./assignQuotePopupSearch";
import UiIcon from "../../ui/icons/uiIcon";
import {usePrevious} from "../../../misc/helperHooks";
import {toggleArrayValue} from "../../look/lookNavigation/lookFunctions";
import LoadingSpinner from "../../ui/loadingSpinner";


const AssignQuoteContractSelection = (props) => {

  const {isActive, contractsList, selectedContracts, changeContext, assignQuotePopupSearchText, contractsReceived,
    fabricatorData} = props;

  const prevIsActive = usePrevious(isActive);

  useEffect(() => {
    if (isActive && (prevIsActive !== isActive)) {
      changeContext({selectedContracts: contractsList
          .filter(contract => contract.selected)
          .map(contract => contract.id)
      });
    }
  }, [changeContext, isActive, prevIsActive, contractsList]);

  const handleContractCheck = (contract) => {
    changeContext({selectedContracts: toggleArrayValue(selectedContracts, contract.id)});
  }

  let renderContractList = contractsList;
  if (assignQuotePopupSearchText) {
    const searchString = assignQuotePopupSearchText.toLowerCase();
    renderContractList = contractsList.filter(contract => contract.name
      && contract.name.toLowerCase().includes(searchString))
  }

  return (
    <div className={"ass ass--content" + (isActive ? " ass--active" : "")}>
      <AssignQuotePopupSearch/>
      <div className="ass-content">
        <div className="ass-content__cell">
          {!contractsReceived ? <LoadingSpinner size="smaller"/> : (
            <ul className="ass-list">
              {renderContractList.map((contract, contractIndex) => {
                if (fabricatorData.isAmericanStandard && contractIndex === 0) {
                  // We need to always have the spec sheet loading for American standard as the first doc without selecting it
                  return null
                }
                const isChecked = selectedContracts.includes(contract.id);
                const onClick = () => handleContractCheck(contract);
                return (
                  <li className="ass-list__item" key={contract.id}>
                    <div className={"ui-checkbox ui-checkbox--small" + (isChecked ? " ui-checkbox--checked-svg" : "")}
                         onClick={onClick}>
                      <div className="ui-checkbox__svg">
                        <UiIcon icon="checkmark"/>
                      </div>
                    </div>
                    <span className="ui-checkbox__label bold" onClick={onClick}>
                      {contract.name}
                    </span>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
};

AssignQuoteContractSelection.propTypes = {
  isActive: PropTypes.bool.isRequired,
  changeContext: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => {
  const {contractsList, contractsReceived} = store.contractSigningState;
  const {assignQuotePopupSearchText} = store.assignQuoteState;
  return {
    contractsList,
    fabricatorData: store.fabricatorState,
    assignQuotePopupSearchText,
    contractsReceived,
  };
};

export default connect(mapStateToProps)(AssignQuoteContractSelection)

